export default {
    accept: "application/json; charset=utf-8",
}
  